import React from 'react';
import * as FiIcons from 'react-icons/fi';

const SafeIcon = ({ icon: Icon, name, className, ...props }) => {
  if (Icon) return <Icon className={className} {...props} />;
  
  if (name && FiIcons[`Fi${name}`]) {
    const NamedIcon = FiIcons[`Fi${name}`];
    return <NamedIcon className={className} {...props} />;
  }

  return <FiIcons.FiAlertCircle className={className} {...props} />;
};

export default SafeIcon;